import { render, staticRenderFns } from "./PriceTiersSummary.vue?vue&type=template&id=f609022c&scoped=true&"
import script from "./PriceTiersSummary.vue?vue&type=script&lang=js&"
export * from "./PriceTiersSummary.vue?vue&type=script&lang=js&"
import style0 from "./PriceTiersSummary.vue?vue&type=style&index=0&id=f609022c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f609022c",
  null
  
)

component.options.__file = "PriceTiersSummary.vue"
export default component.exports